export const PATH = '/smartcargas/winner';
export const PAGE_TITLE = 'SmartCargas.WonOffers.Title';
export const MAIN_TITLE = 'SmartCargas.WonOffers.MainTitle';
